<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>日前调度</el-breadcrumb-item>
          <el-breadcrumb-item>查看调度</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="info">
            <div id="pane">
              <div ref="vppPlans" style="width: 50%; height: 400px"></div>
              <div ref="vppPrices" style="width: 50%; height: 400px"></div>
            </div>
            <div>
              <div ref="responsePlan" style="width: 100%; height: 400px"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button plain @click="back">返回上一页</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../../js/axios.config";
import time96 from "../../../js/timeSlots";
import * as echarts from "echarts";
export default {
  data() {
    return {
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    //初始化数据
    initData() {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      let id = _this.$route.query.id || ""; //获取ID
      if (!id) {
        _parent.$alert("参数有误，找不到订单信息。", "错误提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            _this.back();
          },
        });
      } else {
        AxiosAjax({
          url: "/v2/getDayaheadPlanDetails/" + id,
          loading: true,
          success: function (res) {
            if (res.data.data.responsePlan.length != 0) {
              _this.responsePlan(res.data.data.responsePlan);
            }
            if (Object.values(res.data.data.vppPlans).length != 0) {
              _this.charts(res.data.data.vppPlans, "vppPlans");
            }
            if (Object.values(res.data.data.vppPrices).length != 0) {
              _this.charts(res.data.data.vppPrices, "vppPrices");
            }
          },
        });
      }
    },
    responsePlan(data) {
      this.chart = echarts.init(this.$refs.responsePlan);

      data.forEach((el) => {
        el.value = [];
        for (let i = 0; i < time96.length; i++) {
          const timeStr = time96[i];
          const existsInData = Object.keys(el.declare).some(
            (item) => item === timeStr
          );
          el.value.push(
            existsInData
              ? el.declare[
                  Object.keys(el.declare).find((item) => item === timeStr)
                ]
              : null
          );
        }
      });
      const option = {
        title: {
          text: "不同园区/充电站/楼宇/储能站具体计划",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: time96,
        },
        yAxis: {
          type: "value",
        },
        series: data.map((line) => ({
          name: line.resourceId,
          type: "line",
          data: line.value,
        })),
      };
      this.chart.setOption(option);
    },
    charts(data, el) {
      let label = [];
      let value = [];

      for (let key in data) {
        label.push(key);
        value.push(data[key]);
      }
      let element;
      let text;
      if (el == "vppPlans") {
        if (this.$refs.vppPlans) {
          element = this.$refs.vppPlans;
        }
        text = "负荷聚合商或大用户总的日前调度计划";
      } else if (el == "vppPrices") {
        if (this.$refs.vppPrices) {
          element = this.$refs.vppPrices;
        }
        text = "邀约时段内的 96 点价格曲线(元/MWh)";
      }
      const chartInstance = echarts.init(element);
      chartInstance.setOption({
        title: { text: text },
        tooltip: {},
        xAxis: {
          type: "category",
          data: label,
        }, // 获取标签数据
        yAxis: { type: "value" },
        series: [
          {
            name: "96小时数据",
            type: "line",
            data: value, // 获取数据点数据
            lineStyle: { smooth: true }, // 添加平滑曲线效果
          },
        ],
      });
    },

    //跳转链接
    linkUrl: function (url) {
      window.location.href = url;
    },
    //返回上一页
    back() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
  },
};
</script>
<style scoped>
.content-box .card-form .dl-box dl dt {
  font-weight: bold;
  color: #000000;
  width: 25%;
}
#pane {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/VirtualPowerPlant/DayaheadPlan/DayaheadPlanShow.vue